import React from "react";

// You can replace this SVG with your Fly-Inn logo or any animated SVG/logo
const AnimatedLogo = () => (
  <div className="flex justify-center mb-6">
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-flyin-spin"
    >
      <circle
        cx="40"
        cy="40"
        r="38"
        // Changed stroke color to a success green
        stroke="#4CAF50" // A pleasant green color (Material Design Green 500)
        strokeWidth="4"
        fill="#fff"
      />
      <path
        d="M24 40l12 12 20-24"
        // Changed stroke color to a success green
        stroke="#4CAF50" // A pleasant green color
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="animate-flyin-check"
      />
    </svg>
    <style>{`
      /* Keeping animations as they are */
      .animate-flyin-spin { animation: flyin-spin 2s cubic-bezier(.68,-0.55,.27,1.55) infinite alternate; }
      @keyframes flyin-spin { 0% { transform: rotate(-10deg); } 100% { transform: rotate(10deg); } }
      .animate-flyin-check { stroke-dasharray: 60; stroke-dashoffset: 60; animation: flyin-check 1s forwards 0.5s; }
      @keyframes flyin-check { to { stroke-dashoffset: 0; } }
    `}</style>
  </div>
);

const SuccessModal = ({
  open,
  message,
  onCTA,
  ctaTitle = "View My Businesses",
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0  flex items-center justify-center bg-black/40 backdrop-blur-sm z-[9999999]">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 relative flex flex-col items-center animate-fadeIn">
        <AnimatedLogo />
        <h2 className="text-2xl font-extrabold text-green-700 mb-2 text-center">
          Success! 🎉
        </h2>
        <p className="text-gray-700 text-lg mb-6 text-center">
          {message || "Your business was added successfully."}
        </p>
        <button
          className="mt-2 px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-xl shadow-lg hover:from-green-700 hover:to-green-800 transition text-lg focus:outline-none focus:ring-2 focus:ring-green-300"
          onClick={onCTA}
        >
          {ctaTitle}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
